import useCreateScreening from './useCreateScreening';
import { useTranslateTest } from './useTranslateTest';

export const useQuestionHandlers = (isTranslateABM = false) => {
  // defined the hook to use based on the isTranslateABM flag
  const createHandlers = useCreateScreening();
  const translateHandlers = useTranslateTest();
  return isTranslateABM ? translateHandlers : createHandlers;
};
